import { chakra } from '@chakra-ui/react';
import { availablePeriods, Period } from 'enums/shared/period';
import ButtonTabs from 'presentation/components/shared/tabs/ButtonTabs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface PeriodRowProps {
  onPeriodClick: (period: Period) => void;
  selectedPeriod: Period;
}

const PeriodRow: FC<PeriodRowProps> = ({
  onPeriodClick,
  selectedPeriod,
}) => {
  const { t } = useTranslation();

  const periodText: Record<Period, string> = {
    [Period.Month]: t('chartPeriodMonth'),
    [Period.Month3]: t('chartPeriodMonth3'),
    [Period.Month6]: t('chartPeriodMonth6'),
    [Period.StartYear]: t('chartPeriodCurYear'),
    [Period.Year]: t('chartPeriodYear'),
    [Period.AllHistory]: t('chartPeriodAllHistory'),
  };

  return (
    <ButtonTabs
      onChange={(index) => onPeriodClick(availablePeriods[index])}
      index={availablePeriods.indexOf(selectedPeriod)}
      items={availablePeriods.map((period) => periodText[period])}
      isFullWidth
    />
  );
};

export default chakra(PeriodRow);
